import React from 'react';
import type {
    KbArticlePage,
    KbPageReferences
} from '../../../content/types/content/kb-article';
import { PAGE_KB_ARTICLE } from '../../../contentful/content-types';
import Breadcrumbs from '../../components/breadcrumbs/breadcrumbs';

interface KbArticlePageProps {
    entry: KbArticlePage;
}

const getReferencesFromArticle = (page: KbArticlePage): KbPageReferences => ({
    kbHomePageReference: {
        url: page.homePageReference.url,
        title: page.homePageReference.title
    },
    kbArticlePageReference: {
        url: page.url,
        title: page.title
    }
});

const KbArticle = ({ entry }: KbArticlePageProps) => {
    const { id, title, body } = entry;
    return (
        <>
            {/*SkipLink*/}
            {/*AuthorTools*/}
            <div
                className="topic section-page flex-column-page"
                data-testid="page-template"
            >
                <div className="content">
                    {/*Header*/}
                    <div className="main-content-container flex-container margin-top-medium">
                        {/*PageTree*/}
                        <main className="topic__container">
                            <div className="topic__sub-header">
                                <Breadcrumbs
                                    entryId={id}
                                    pageTree={[]}
                                    type={PAGE_KB_ARTICLE}
                                    context={getReferencesFromArticle(entry)}
                                />
                            </div>
                            {/*NoticeHub*/}
                            <article
                                className="topic__inner-container margin-top-medium"
                                id="maincontent"
                            >
                                <div className="title margin-bottom-medium">
                                    <h1>{title}</h1>
                                </div>

                                <div className="topic__body">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: body
                                        }}
                                    />
                                </div>
                                {/*Sidebar*/}
                            </article>
                        </main>
                    </div>
                </div>
                {/*Footer*/}
            </div>
        </>
    );
};

export default KbArticle;
